import { Component, OnInit, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from "../vocabulary.module.config";
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import * as fromStore from '../store/reducers';
import * as vocabularyActions from '../store/actions';
import { ACTION_ERROR, ActionError } from '../../pillar/common/actions/ActionError';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';

@Component({
  selector: 'brd-delete-code-system-confirmation-dialog',
  templateUrl: './delete-code-system-confirmation-dialog.component.html',
  styleUrls: ['./delete-code-system-confirmation-dialog.component.scss']
})
export class DeleteCodeSystemConfirmationDialogComponent implements OnInit, OnDestroy {

  eventUnsubscribe: Subscription;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  key: string;
  vocabularyName:string;
  deleteActionIdentifier: string;
  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;


  constructor(public dialogRef: MatDialogRef<any>,
    private router: Router,
    private actions$: Actions,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.key = data.key;
    this.vocabularyName = data.vocabularyName
  }

  ngOnInit() {
    this.actions$.ofType(vocabularyActions.DELETE_CODESYSTEMVERSION_DRAFT_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe((a: vocabularyActions.DeleteCodeSystemVersionDraftSuccessAction) => {
        this.router.navigateByUrl('/configuration');
        this.close();
      });

    this.actions$.ofType(ACTION_ERROR)
      .filter((a: ActionError) => this.deleteActionIdentifier && a.payload.action.identifier === this.deleteActionIdentifier)
      .takeUntil(this.destroyed$)
      .subscribe((p: ActionError) => {
        for (let error in p.payload.errors) {
          if (p.payload.errors.hasOwnProperty(error)) {
            this.alerts.addError(p.payload.errors[error]);
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
  }

  delete() {
    this.store.dispatch(new vocabularyActions.DeleteCodeSystemVersionDraftAction({ key: this.key }));
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/delete-code-system-confirmation-dialog.component.ts